import { useMutation, gql } from "@apollo/client";
import { CreateSoInput, CreateSoMutation, CreateSoMutationVariables } from "../types/types";
import { useGeneralSoContext } from "src/common/context";

/** Shared with `useCreateSoWithCaptcha`, which runs the same document behind the captcha ladder. */
export const CREATE_SO_MUTATION = gql(`
  mutation CreateSo($input: CreateSoInput!) {
      createSo(input: $input)
  }
`);

export function useCreateSo() {
  const { setSoId } = useGeneralSoContext();
  const [mutation, info] = useMutation<CreateSoMutation, CreateSoMutationVariables>(CREATE_SO_MUTATION);
  const createSo = async (input: CreateSoInput) => {
    const { data } = await mutation({
      variables: { input },
    });
    if (data?.createSo) {
      setSoId(data.createSo);
    }
    return data;
  };
  return [createSo, info] as const;
}
